// Rightmost, not nearest: picking the anchor by def adjacency but splicing at its SAVED index lands a column anywhere.
const findLastPrecedingIndex = (
  orderedFields: string[],
  columns: readonly { field: string }[],
  index: number
): number => {
  let last = -1;
  for (let i = 0; i < index; i++) {
    const position = orderedFields.indexOf(columns[i].field);
    if (position > last) last = position;
  }
  return last;
};

const insertAt = (orderedFields: string[], field: string, anchor: number): void => {
  if (anchor === -1) orderedFields.unshift(field);
  else orderedFields.splice(anchor + 1, 0, field);
};

// A column the saved order lacks goes after every def-array column ahead of it, not to MUI's far right; one it has stays.
export const reconcileMissingColumnOrder = (orderedFields: string[], columns: readonly { field: string }[]): void => {
  columns.forEach((col, index) => {
    if (orderedFields.includes(col.field)) return;
    insertAt(orderedFields, col.field, findLastPrecedingIndex(orderedFields, columns, index));
  });
};

export const completeColumnOrder = (
  orderedFields: readonly string[],
  columns: readonly { field: string }[]
): string[] => {
  const order = [...orderedFields];
  reconcileMissingColumnOrder(order, columns);
  return order;
};

// A field absent from orderedFields sorts after every listed one; indexOf's -1 would put it first.
export const sortByOrderedFields = <T extends { field: string }>(
  columns: readonly T[],
  orderedFields: readonly string[]
): T[] => {
  const positionOf = (field: string) => {
    const index = orderedFields.indexOf(field);
    return index === -1 ? orderedFields.length : index;
  };
  return [...columns].sort((a, b) => positionOf(a.field) - positionOf(b.field));
};
